import React from 'react';
import DecorationProcurement from './decorationProcurement';
import request from '../../service/request';
import { DECORATIONLIST_POST_LIST } from '../../service/api';

async function action({query, cookie, fetch }) {
    const params = Object.assign({
        "size": 50,
        "type": 1,
        "showStatus": 1,
        "page": 1
    },query);
    const [res] = await Promise.all([
        request.POST({
            url: DECORATIONLIST_POST_LIST,
            params,
            headers: cookie ? {
                cityCode: cookie['cityCode'] || 420200
            } : {}
        }),
    ]);
    const listArr = [[], [], [], []]
    if (res && res.data && res.data.records) {
        res.data.records.forEach((item,index) => {
            listArr[index % 4].push(item)
        });
    }
    console.log(listArr,556)
    const pageData = {
        list:listArr,
        params,
        total:res.data.total || 0
    }
    return {
        title: '东楚优房',
        chunks: ['decorationProcurement'],
        keywords: '东楚优房',
        description: '东楚优房',
        component: (
            <DecorationProcurement pageData={pageData}  />
        )
    };
}


export default action;
